import React, { Component } from "react";

// components
import { DeliveredItem } from '../../parts/Basket/DeliveredItem';
import CardTitlePart from "../../parts/CardTitlePart";
import HtmlPart from "../../parts/HtmlPart";

const ORDER_FULLY_DELIVERED_STATE = 3;
const ORDER_PARTIALLY_DELIVERED_STATE = 2;

class _OrderDeliveredCard extends Component {
    getOrderDeliveredMessage() {
        var message = this.props.orderDeliveryState == ORDER_FULLY_DELIVERED_STATE
            ? `<p>All items in your order have been delivered to your address.
            Thank you for shopping with Sofology.</p>`
            : `<p>Your order has been partially delivered! 
            Some items have arrived, while others are still on their way.</p>`;

        return <HtmlPart htmlString={message} />;
    }

    renderDeliveredItems(items) {
        return (
            <ul className="basket u-padding-top-small u-padding-x-small u-padding-bottom-small">
                {items.map((item, i) => <DeliveredItem item={item} key={`os-basket-item-${i}`} />)}
            </ul>
        );
    }

    render() {
        const {
            deliveredItems,
            orderRef,
            orderNo,
            title
        } = this.props;

        let isOrderPartiallyDelivered = this.props.orderDeliveryState === ORDER_PARTIALLY_DELIVERED_STATE;

        return (
            <div>
                <CardTitlePart title={title} />
                <div style={{ overflow: "hidden" }}
                    className="basket-wrap u-padding-small u-pale-grey-bg"
                >
                    <div className="u-padding-tiny u-text-center">
                        {this.getOrderDeliveredMessage()}
                    </div>
                    {isOrderPartiallyDelivered && this.renderDeliveredItems(deliveredItems)}
                    <div className="u-padding-tiny u-padding-top-small u-text-center c-event-feed__card__extra-info">
                        <strong>Order Number:</strong> {`${orderRef}/${orderNo}`}
                    </div>
                </div>
            </div>
        );
    }
}

export default _OrderDeliveredCard;



// WEBPACK FOOTER //
// ./src/cards/templates/OrderDeliveredCard.js